const apiUrl = process.env.REACT_APP_API_URL;

export const GetJutgeUsuariIdPointsHistory = async (id: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/usuaris/${id}/points-history`);
        const jsonData = await response.json();
        return Array.isArray(jsonData) ? jsonData : [];
    } catch (error) {
        console.log('Error al obtener el historial de puntos:', error);
        return [];
    }
};
